import { motion } from "framer-motion";
import UnityActionsWindow from "../UnityActionsWindow/UnityActionsWindow";
import { useContext } from "react";
import { ModalContext } from "hooks/ModalProvider";

type UnityMenuProps = {
  sendMessageToUnity: (gameObjectName: string, methodName: string, parameter?: any) => void;
};

const UnityMenu = ({ sendMessageToUnity }: UnityMenuProps) => {
  const { modalType } = useContext(ModalContext);

  return (
    <motion.div
      key="discrete-slider-container"
      className="absolute top-10 w-full h-max z-50 left-0 flex items-center justify-center flex-wrap gap-8 pointer-events-none"
      initial={false}
      animate={{ top: 10 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      {/* UnityActionsWindow - No Animation Needed Here Anymore */}
      {modalType === '' && (
        <div className="w-max flex items-center justify-center pointer-events-auto">
          <UnityActionsWindow sendMessageToUnity={sendMessageToUnity} />
        </div>
      )}
    </motion.div>
  );
};

export default UnityMenu;
